interface ISelection {
  resource: number | { [key: string]: any };
  cases: number;
  singles: number;
  inventory?: number | null;
  quantityInCase?: number | null;
}

export function isValidSelections(selections: ISelection[]): boolean {
  console.log("Validating selections:", selections);

  const validSelections = selections.filter(
    (item) => typeof item.resource === "number"
  );

  if (validSelections.length === 0) return false;

  return validSelections.every((item) => {
    const hasQuantity = item.cases > 0 || item.singles > 0;
    if (!hasQuantity) return false;

    if (item.quantityInCase == null || item.inventory == null) {
      console.log(`Missing data for resource ${item.resource}:`, {
        quantityInCase: item.quantityInCase,
        inventory: item.inventory,
      });
      return false;
    }

    const totalRequested = item.cases * item.quantityInCase + item.singles;

    const isInventorySufficient = totalRequested <= item.inventory;

    if (!isInventorySufficient) {
      console.log(`Insufficient inventory for resource ${item.resource}:`, {
        requested: totalRequested,
        available: item.inventory,
      });
    }

    return isInventorySufficient;
  });
}
